// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3K46l","actions":"GroupTable_actions__2G8hx","deleteModalFooter":"GroupTable_deleteModalFooter__1g29K"};